import React, {useEffect, useState} from 'react';
import './index.scss';
import moment from 'moment/moment';
import Coin from '../../SVG/Coin';
import FboDetails from '../../SVG/FBODetails';
import Plus from '../../SVG/Plus';
import UnAssignIcon from '../../SVG/UnAssignIcon';
import ClearInspection from '../../SVG/ClearInspection';
import RefreshEquipment from '../../SVG/RefreshEquipment';
import Pencil from '../../SVG/Pencil';
import SwitchIcon from '../../SVG/SwitchIcon';
import Trash from '../../SVG/Trash';
import {useLocation, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {
  useAgencyDeactivateMutation,
  useAgencySetSubscriptionMutation,
  useCancelSubscriptionMutation,
  useClearInspectionsFboMutation,
  useReactivateFboEquipmentsMutation,
  useToggleCustomFormMutation,
  useUnAssignFboMutation,
} from '../../store/builder/inspections.api';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {setLoader} from '../../store/builder/reducer';
import {toast} from 'react-toastify';
import Datepicker from '../Datepicker';
import AssignWithCorporate from '../AssignCorporate';
import AgencyDeleteModal from '../AgencyDeleteModal';
import log from '../../SVG/Log';
import ToggleOffIcon from '../../SVG/ToggleOffIcon';
import useLoader from '../../global/UseLoadingHandler';
import Copy from '../../SVG/Copy';
import { copyText } from '../../global/utils';
import {useTranslation} from '../../hooks/useTranslation';

const AgencyTableCard = ({
  agancy,
  setCurrentItem,
  setCreateModalStatus,
  getAgencies,
  setStartTrialStatus,
  setList,
  setEditPrisingModal,
  currentItem,
  corporateData,
  setTurnOffStatus,
}) => {
  const {t} = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [actionsStatus, setActionsStatus] = useState(false);
  const [reactivateStatus, setReactivateStatus] = useState(false);
  const [dangerShow, setDangerShow] = useState(false);
  const [dangerClearShow, setDangerClearShow] = useState(false);
  const [assignModal, setAssignModal] = useState(false);
  const [unAssignModal, setUnAssignModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [setSubscStatus, setSetSubscStatus] = useState(false);
  const [deactivateStatus, setDeactivateStatus] = useState(false);
  const [turnStatus, setTurnStatus] = useState(false);
  const [subscribtionDates, setSubscribtionDates] = useState({
    end_date: null,
    start_date: null,
  });
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);

  const closeDropdown = () => {
    setList(old => {
      let data = [...old];
      data?.map(item => {
        item.action_status = false;
      });
      return data;
    });
  };

  const [
    cancelSubscription,
    {
      data: cancelSubscriptionData,
      error: cancelSubscriptionError,
      isLoading: cancelSubscriptionIsLoading,
      isSuccess: cancelSubscriptionIsSuccess,
      isError: cancelSubscriptionIsError,
    },
  ] = useCancelSubscriptionMutation();
  const [
    clearInspection,
    {
      data: clearInspectionData,
      error: clearInspectionError,
      isLoading: clearInspectionIsLoading,
      isSuccess: clearInspectionIsSuccess,
      isError: clearInspectionIsError,
    },
  ] = useClearInspectionsFboMutation();
  const [
    reactivate,
    {
      data: reactivateData,
      error: reactivateError,
      isLoading: reactivateIsLoading,
      isSuccess: reactivateIsSuccess,
      isError: reactivateIsError,
    },
  ] = useReactivateFboEquipmentsMutation();
  const [
    unAssignAction,
    {
      data: unAssignActionData,
      error: unAssignActionError,
      isLoading: unAssignActionIsLoading,
      isSuccess: unAssignActionIsSuccess,
      isError: unAssignActionIsError,
    },
  ] = useUnAssignFboMutation();

  const [
    setSubscription,
    {
      data: setSubscriptionData,
      error: setSubscriptionError,
      isLoading: setSubscriptionIsLoading,
      isSuccess: setSubscriptionIsSuccess,
      isError: setSubscriptionIsError,
    },
  ] = useAgencySetSubscriptionMutation();

  const [
    deactivate,
    {
      data: deactivateData,
      error: deactivateError,
      isLoading: deactivateIsLoading,
      isSuccess: deactivateIsSuccess,
      isError: deactivateIsError,
    },
  ] = useAgencyDeactivateMutation();

  const [
    toggleCustomForm,
    {
      data: toggleCustomFormData,
      error: toggleCustomFormError,
      isLoading: toggleCustomFormIsLoading,
      isSuccess: toggleCustomFormIsSuccess,
      isError: toggleCustomFormIsError,
    },
  ] = useToggleCustomFormMutation();

  const [errorHandler, setErrorHandler] = useErrorHandler([
    cancelSubscriptionError,
    clearInspectionError,
    reactivateError,
    unAssignActionError,
    setSubscriptionError,
    deactivateError,
    toggleCustomFormError,
  ]);

  useLoader([
    cancelSubscriptionIsLoading,
    clearInspectionIsLoading,
    reactivateIsLoading,
    unAssignActionIsLoading,
    setSubscriptionIsLoading,
    deactivateIsLoading,
    toggleCustomFormIsLoading,
  ]);

  useEffect(() => {
    if (
      dangerShow ||
      dangerClearShow ||
      reactivateStatus ||
      setSubscStatus ||
      deactivateStatus ||
      assignModal ||
      unAssignModal ||
      deleteModal
    ) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [
    dangerShow,
    dangerClearShow,
    reactivateStatus,
    setSubscStatus,
    deactivateStatus,
    assignModal,
    unAssignModal,
    deleteModal,
  ]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        e.target.closest('.trialCard__action') === null &&
        e.target.closest('.management__table-settings') === null
      ) {
        closeDropdown();
      }
    };

    window.addEventListener('click', handleClickOutside);
    
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [closeDropdown]);

  useEffect(() => {
    if (cancelSubscriptionIsLoading) {
      dispatch(setLoader(true));
    }
    if (cancelSubscriptionIsSuccess) {
      dispatch(setLoader(false));
    }
    if (cancelSubscriptionIsError) {
      dispatch(setLoader(false));
    }
  }, [
    cancelSubscriptionIsLoading,
    cancelSubscriptionIsSuccess,
    cancelSubscriptionIsError,
  ]);

  useEffect(() => {
    setSubscribtionDates(old => ({
      ...old,
      start_date: currentItem?.subscription_start_date,
      end_date: currentItem?.subscription_end_date,
    }));
  }, [currentItem]);

  const handleSubscribtionSubmit = e => {
    e.preventDefault();
    if (subscribtionDates.start_date) {
      dispatch(setLoader(true));
      setSubscription({
        agency_id: agancy?.id?.toString(),
        start_date: moment(subscribtionDates.start_date).format('YYYY-MM-DD'),
        end_date: moment(subscribtionDates.end_date).format('YYYY-MM-DD'),
      })
        .unwrap()
        .then(res => {
          toast.success(res.message);
          setSetSubscStatus(false);
          dispatch(setLoader(false));
          getAgencies();
          setSubscribtionDates({
            end_date: null,
            start_date: null,
          });
        })
        .catch(err => {
          setSetSubscStatus(false);
          dispatch(setLoader(false));
        });
    } else {
      toast.error(t('agency.messages.selectStartDate'));
    }
  };

  const renderDangerSubscription = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('agency.modals.cancelSubscription.title')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setDangerShow(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {t('agency.modals.cancelSubscription.message')}
          </div>
          <div className='modal__content-bottom'>
            <button
              className='save danger third'
              onClick={() => {
                dispatch(setLoader(true));
                cancelSubscription({
                  id: agancy?.id,
                  data: {cancel_now: true},
                }).then(res => {
                  dispatch(setLoader(false));
                  toast.success(res.data.message);
                  setDangerShow(false);
                  getAgencies();
                });
              }}
            >
              {t('agency.modals.cancelSubscription.cancelNow')}
            </button>
            <button
              className='close almost'
              onClick={() => {
                dispatch(setLoader(true));
                cancelSubscription({
                  id: agancy?.id,
                  data: {cancel_now: false},
                }).then(res => {
                  dispatch(setLoader(false));
                  toast.success(res.data.message);
                  setDangerShow(false);
                  getAgencies();
                });
              }}
            >
              {t('agency.modals.cancelSubscription.cancelAtEnd')}
            </button>
          </div>
        </div>
        <div className='modal__bg' onClick={() => setDangerShow(false)}></div>
      </div>
    );
  };

  const renderDangerClear = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('agency.modals.clearInspections.title')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setDangerClearShow(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {t('agency.modals.clearInspections.message')}
          </div>
          <div className='modal__content-bottom'>
            <button
              className='save danger '
              onClick={() => {
                dispatch(setLoader(true));
                clearInspection({confirmed: true, agency_id: agancy?.id})
                  .then(res => {
                    dispatch(setLoader(false));
                    toast.success(res.data.message);
                    setDangerClearShow(false);
                    getAgencies();
                  })
                  .catch(err => {
                    dispatch(setLoader(false));
                    setDangerClearShow(false);
                  });
              }}
            >
              {t('agency.modals.clearInspections.clear')}
            </button>
            <button
              className='close almost'
              onClick={() => {
                setDangerClearShow(false);
              }}
            >
              {t('actions.cancel')}
            </button>
          </div>
        </div>
        <div
          className='modal__bg'
          onClick={() => setDangerClearShow(false)}
        ></div>
      </div>
    );
  };

  const renderReactivate = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('agency.modals.reactivateEquipment.title')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setReactivateStatus(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {t('agency.modals.reactivateEquipment.message')}
          </div>
          <div className='modal__content-bottom'>
            <button
              className='save danger '
              onClick={() => {
                dispatch(setLoader(true));
                reactivate({confirmed: true, agency_id: agancy?.id})
                  .then(res => {
                    dispatch(setLoader(false));
                    toast.success(t('agency.messages.equipmentReactivatedSuccess'));
                    setReactivateStatus(false);
                    getAgencies();
                  })
                  .catch(err => {
                    dispatch(setLoader(false));
                    setReactivateStatus(false);
                  });
              }}
            >
              {t('agency.modals.reactivateEquipment.reactivate')}
            </button>
            <button
              className='close almost'
              onClick={() => {
                setReactivateStatus(false);
              }}
            >
              {t('actions.cancel')}
            </button>
          </div>
        </div>
        <div
          className='modal__bg'
          onClick={() => setReactivateStatus(false)}
        ></div>
      </div>
    );
  };

  const renderUnAssignModal = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('agency.modals.unassign.title')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setUnAssignModal(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {t('agency.modals.unassign.message')}
          </div>
          <div className='modal__content-bottom'>
            <button
              className='close'
              onClick={() => {
                setUnAssignModal(false);
              }}
            >
              {t('actions.cancel')}
            </button>
            <button
              className='save danger '
              onClick={() => {
                dispatch(setLoader(true));
                unAssignAction({agency_id: agancy?.id})
                  .then(res => {
                    dispatch(setLoader(false));
                    toast.success(res.data.message);
                    setUnAssignModal(false);
                    getAgencies();
                  })
                  .catch(err => {
                    dispatch(setLoader(false));
                    setUnAssignModal(false);
                  });
              }}
            >
              {t('agency.modals.unassign.unassign')}
            </button>
          </div>
        </div>
        <div
          className='modal__bg'
          onClick={() => setUnAssignModal(false)}
        ></div>
      </div>
    );
  };

  const renderSubscriptionDates = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>
              {agancy?.subscription_start_date
                ? t('agency.modals.subscriptionDates.editTitle')
                : t('agency.modals.subscriptionDates.setTitle')}
            </p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setSetSubscStatus(false)}
            />
          </div>
          <div className='modal__content-body'>
            <div className='modal__content-subscriptionDates'>
              <div>
                <p className='trial__modal-title'>{t('agency.modals.subscriptionDates.startDate')}</p>
                <Datepicker
                  width={195}
                  setValue={e =>
                    setSubscribtionDates(old => ({
                      ...old,
                      start_date: moment(e).format('YYYY-MM-DD'),
                    }))
                  }
                  value={
                    subscribtionDates?.start_date !== 'Invalid date'
                      ? subscribtionDates?.start_date
                      : null
                  }
                />
              </div>
              <div className='divider'></div>
              <div>
                <p className='trial__modal-title'>{t('agency.modals.subscriptionDates.endDate')}</p>
                <Datepicker
                  width={195}
                  setValue={e =>
                    setSubscribtionDates(old => ({
                      ...old,
                      end_date: moment(e).format('YYYY-MM-DD'),
                    }))
                  }
                  value={
                    subscribtionDates?.end_date !== 'Invalid date'
                      ? subscribtionDates?.end_date
                      : null
                  }
                />
              </div>
            </div>
          </div>
          <div className='modal__content-bottom'>
            <button
              className='close'
              onClick={() => {
                setSetSubscStatus(false);
              }}
            >
              {t('actions.close')}
            </button>
            <button className='save' onClick={handleSubscribtionSubmit}>
              {t('actions.confirm')}
            </button>
          </div>
        </div>
        <div
          className='modal__bg'
          onClick={() => {
            setSetSubscStatus(false);
          }}
        ></div>
      </div>
    );
  };

  const renderDeactivate = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>{t('agency.modals.deactivate.title')}</p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setDeactivateStatus(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {t('agency.modals.deactivate.message')}
          </div>
          <div className='modal__content-bottom'>
            <button
              className='save danger '
              onClick={() => {
                dispatch(setLoader(true));
                deactivate(agancy?.id)
                  .unwrap()
                  .then(res => {
                    dispatch(setLoader(false));
                    toast.success(t('agency.messages.fboDeactivatedSuccess'));
                    setDeactivateStatus(false);
                    getAgencies();
                  })
                  .catch(err => {
                    dispatch(setLoader(false));
                    setReactivateStatus(false);
                  });
              }}
            >
              {t('agency.modals.deactivate.deactivate')}
            </button>
            <button
              className='close almost'
              onClick={() => {
                setDeactivateStatus(false);
              }}
            >
              {t('actions.cancel')}
            </button>
          </div>
        </div>
        <div
          className='modal__bg'
          onClick={() => setDeactivateStatus(false)}
        ></div>
      </div>
    );
  };

  const renderTurnCustomForm = () => {
    return (
      <div className='modal'>
        <div className='modal__content'>
          <div className='modal__content-head'>
            <p>
              {t('agency.modals.turnCustomForm.title', {status: agancy?.custom_inspections_enabled ? t('agency.modals.turnCustomForm.turnOff') : t('agency.modals.turnCustomForm.turnOn')})}
            </p>
            <img
              className='modal__content-exit'
              src='/assets/icons/close.svg'
              alt='close'
              onClick={() => setTurnStatus(false)}
            />
          </div>
          <div
            className='modal__content-body'
            style={{display: 'flex', justifyContent: 'center'}}
          >
            {agancy?.custom_inspections_enabled
              ? t('agency.modals.turnCustomForm.messageOff')
              : t('agency.modals.turnCustomForm.messageOn')}
          </div>
          <div className='modal__content-bottom'>
            <button
              className='save danger '
              onClick={() => {
                dispatch(setLoader(true));
                toggleCustomForm(agancy?.id)
                  .unwrap()
                  .then(res => {
                    dispatch(setLoader(false));
                    toast.success(res.message);
                    setTurnStatus(false);
                    getAgencies();
                  })
                  .catch(err => {
                    dispatch(setLoader(false));
                    setTurnStatus(false);
                  });
              }}
            >
              {agancy?.custom_inspections_enabled ? t('agency.modals.turnCustomForm.turnOff') : t('agency.modals.turnCustomForm.turnOn')}
            </button>
            <button
              className='close almost'
              onClick={() => {
                setTurnStatus(false);
              }}
            >
              {t('actions.cancel')}
            </button>
          </div>
        </div>
        <div className='modal__bg'></div>
      </div>
    );
  };

  return (
    <div className='agencyCard' key={agancy?.id}>
      {dangerShow && renderDangerSubscription()}
      {dangerClearShow && renderDangerClear()}
      {reactivateStatus && renderReactivate()}
      {setSubscStatus && renderSubscriptionDates()}
      {deactivateStatus && renderDeactivate()}
      {turnStatus && renderTurnCustomForm()}
      {assignModal && (
        <AssignWithCorporate
          exit={() => setAssignModal(false)}
          getAgencies={getAgencies}
          currentItem={currentItem}
          corporateData={corporateData}
        />
      )}
      {unAssignModal && renderUnAssignModal()}
      {deleteModal && (
        <AgencyDeleteModal
          exit={() => setDeleteModal(false)}
          currentFBO={currentItem}
          getAgencies={getAgencies}
        />
      )}
      {agancy?.action_status === true && (
        <div className='management__table-settings fbo'>
          {userInfo?.is_global  && <div
              className='trial__dropdown-elem'
            onClick={() => {
                copyText(t('actions.copiedNDXID'), agancy?.id)
                closeDropdown();
              }}>
            <Copy color={'#999999'}/>
            <span>{t('agency.actions.ndxId')} {agancy?.id}</span>
          </div>}
          <div
            className='management__table-edit'
            onClick={() => {
              setCurrentItem(agancy);
              setSetSubscStatus(true);
              closeDropdown();
            }}
          >
            <Coin color={'#999999'} />
            <span>
              {agancy?.subscription_start_date
                ? t('agency.actions.editSubscriptionDates')
                : t('agency.actions.setSubscriptionDates')}
            </span>
          </div>
          <div
            className='management__table-edit'
            onClick={() => {
              setCurrentItem(agancy);
              setTurnStatus(true);
              closeDropdown();
            }}
          >
            <ToggleOffIcon color={'#999999'} />
            <span>
              {agancy?.custom_inspections_enabled
                ? t('agency.actions.turnOffCustomForm')
                : t('agency.actions.turnOnCustomForm')}
            </span>
          </div>
          <div
            className='management__table-edit details'
            onClick={() => {
              setActionsStatus(false);
              navigate(`/fbo/${agancy.id}`);
              closeDropdown();
            }}
          >
            <FboDetails />
            <span>{t('agency.actions.fboDetails')}</span>
          </div>
          <div
            className='management__table-edit details'
            onClick={() => {
              setCurrentItem(agancy);
              setAssignModal(true);
              closeDropdown();
            }}
          >
            <Plus color={'#999999'} />
            <span>
              {agancy?.is_assigned_to_corporate
                ? t('agency.actions.reassignWithCorporate')
                : t('agency.actions.assignWithCorporate')}
            </span>
          </div>
          {agancy?.is_assigned_to_corporate && (
            <div
              className='management__table-edit details'
              onClick={() => {
                setCurrentItem(agancy);
                setUnAssignModal(true);
                closeDropdown();
              }}
            >
              <UnAssignIcon color={'#999999'} />
              <span>{t('agency.actions.unassign')}</span>
            </div>
          )}

          {agancy?.can_be_cleared && (
            <div
              className='management__table-edit details'
              onClick={() => {
                setDangerClearShow(true);
                setActionsStatus(false);
                closeDropdown();
              }}
            >
              <ClearInspection color='#999999' />
              <span>{t('agency.actions.clearInspection')}</span>
            </div>
          )}

          <div
            className='management__table-edit details'
            onClick={() => {
              setReactivateStatus(true);
              setActionsStatus(false);
              closeDropdown();
            }}
          >
            <RefreshEquipment color={'#999999'} />
            <span>{t('agency.actions.reactivateEquipment')}</span>
          </div>
          <div
            className='management__table-edit details'
            onClick={() => {
              setCurrentItem(agancy);
              setCreateModalStatus(true);
              setActionsStatus(false);
              closeDropdown();
            }}
          >
            <Pencil color={'#999999'} />
            <span>{t('agency.actions.editFbo')}</span>
          </div>
          <div
            className='management__table-edit'
            onClick={() => {
              if (agancy?.inspection_enabled) {
                setTurnOffStatus(true);
                setCurrentItem(agancy);
              } else {
                setStartTrialStatus(true);
                setCurrentItem(agancy);
              }
              closeDropdown();
            }}
          >
            <SwitchIcon color={'#999999'} />
            <span>
              {agancy?.inspection_enabled ? t('agency.actions.turnOffInspections') : t('agency.actions.turnOnInspections')}
            </span>
          </div>
          <div
            className='management__table-edit'
            onClick={() => {
              setDeactivateStatus(true);
              closeDropdown();
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <path
                d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
                stroke='#999999'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M4.92993 4.92993L19.0699 19.0699'
                stroke='#999999'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
            <span>{t('agency.actions.deactivate')}</span>
          </div>
          <div
            className='management__table-edit'
            onClick={() => {
              setCurrentItem(agancy);
              setDeleteModal(true);
              closeDropdown();
            }}
          >
            <Trash color={'#DA6767'} />
            <span>{t('agency.actions.deleteFbo')}</span>
          </div>
        </div>
      )}
      <div className='agencyCard__left'>
        <div className='agencyCard__left-agency'>
          <div className='agencyCard__left-photo'>
            <img
              className='agencyCard__left-logo'
              src={agancy.logo}
              alt='logo'
            />
          </div>
          <p className='agencyCard__left-id'>#{agancy?.id}</p>
        </div>
        <div className='agencyCard__left-info'>
          <div className='agencyCard__left-text'>
            <p className='agencyCard__left-name'>{agancy?.title}</p>
            <p className='agencyCard__left-airport'>
              {t('agency.cardDetails.airportId')}: <span>{agancy?.airport_id}</span>
            </p>
            <p className='agencyCard__left-airport'>
              {t('agency.cardDetails.corporate')}:{' '}
              <span>
                {agancy?.corporate ? agancy?.corporate : t('agency.cardDetails.noCorporate')}
              </span>
            </p>
            <p className='agencyCard__left-airport'>
              {t('agency.cardDetails.inspectionsRevision')}:{' '}
              <span>
                {agancy?.inspections_revision_label
                  ? agancy?.inspections_revision_label
                  : '???'}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className='agencyCard__mid border'>
        <div className='agencyCard__mid-block'>
          <p className='agencyCard__mid-text'>{t('agency.cardDetails.inspectionStatus')}:</p>
          <span
            className={`agencyCard__mid-status ${agancy?.inspection_enabled ? 'on' : 'off'}`}
          >
            {agancy?.inspection_enabled ? t('agency.cardDetails.on') : t('agency.cardDetails.off')}
          </span>
        </div>
        <div className='agencyCard__mid-block'>
          <p className='agencyCard__mid-text'>{t('agency.cardDetails.inspectionsStartDate')}:</p>
          <span className='agencyCard__mid-subtext'>
            {agancy?.inspection_start_date
              ? moment(agancy?.inspection_start_date).format('D MMM YYYY')
              : '---'}
          </span>
        </div>
        <div className='agencyCard__mid-block'>
          <p className='agencyCard__mid-text'>{t('agency.cardDetails.subscription')}:</p>
          <span className='agencyCard__mid-subtext'>
            {agancy?.subscription_start_date
              ? moment(agancy?.subscription_start_date).format('MM/DD/YYYY')
              : '-'}{' '}
            -{' '}
            {agancy?.subscription_end_date
              ? moment(agancy?.subscription_end_date).format('MM/DD/YYYY')
              : '-'}
          </span>
        </div>
      </div>
      <div className='agencyCard__right'>
        <div className='agencyCard__mid-block'>
          <p className='agencyCard__mid-text'>{t('agency.cardDetails.customForm')}:</p>
          <span
            className={`agencyCard__mid-status ${agancy?.custom_inspections_enabled ? 'on' : 'off'}`}
          >
            {agancy?.custom_inspections_enabled ? t('agency.cardDetails.on') : t('agency.cardDetails.off')}
          </span>
        </div>
        <div className='agencyCard__mid-block'>
          <p className='agencyCard__mid-text'>{t('agency.cardDetails.timezone')}:</p>
          <span className='agencyCard__mid-subtext'>
            {agancy?.timezone ? agancy?.timezone : '---'}
          </span>
        </div>
        <div className='agencyCard__mid-block'>
          <p className='agencyCard__mid-text'>{t('agency.cardDetails.facilitiesEnabled')}:</p>
          <span className='agencyCard__mid-subtext'>
            {agancy?.facilities_enabled ? agancy?.facilities_enabled : '---'}
          </span>
        </div>
        <div className='agencyCard__mid-block'>
          <p className='agencyCard__mid-text'>{t('agency.cardDetails.ssoSiteCode')}:</p>
          <span className='agencyCard__mid-subtext'>
            {agancy?.sso_site_code ? agancy?.sso_site_code : '---'}
          </span>
        </div>
      </div>
      <div className='trialCard__action trial__settings new'>
        <img
          className='trialCard__action-btn'
          src='/assets/icons/dots.svg'
          alt='dots'
          onClick={() => {
            setList(old => {
              let data = [...old];
              data?.map(item => {
                if (item?.id === agancy?.id) {
                  if (item.action_status) {
                    item.action_status = false;
                  } else {
                    item.action_status = true;
                  }
                } else {
                  item.action_status = false;
                }
              });
              return data;
            });
          }}
        />
      </div>
    </div>
  );
};

export default AgencyTableCard;
